import { useState } from 'react';
import { Tooltip, Typography } from 'antd';
import Data from '../../../CustomText/data';
import { RELEASED_MARKER } from './ReleasePhoneNumber';

// A released/soft-deleted number is stored as "<number>-XX" — show the number struck
// through, and reveal the raw stored value on click.
export default function PhoneNumberDisplay({ phoneNumber }) {
  const [expanded, setExpanded] = useState(false);
  const markerIndex = phoneNumber ? phoneNumber.indexOf(RELEASED_MARKER) : -1;

  if (markerIndex < 0) {
    return <Data title="Mobile Number (verified with SMS OTP)" value={phoneNumber} copyable />;
  }

  return (
    <Data title="Mobile Number (released)">
      <Tooltip title={phoneNumber}>
        <span onClick={() => setExpanded(!expanded)} style={{ cursor: 'pointer' }}>
          {expanded
            ? phoneNumber
            : <Typography.Text delete type="secondary">{phoneNumber.slice(0, markerIndex)}</Typography.Text>}
        </span>
      </Tooltip>
    </Data>
  );
}
